import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/pop_close.png'
import _imports_1 from '../assets/image/next.png'
import _imports_2 from '../assets/image/success.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-6b73b73d")

_pushScopeId("data-v-6b73b73d")
const _hoisted_1 = { class: "vr" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { id: "container" }, null, -1)
const _hoisted_3 = { class: "btn" }
const _hoisted_4 = { class: "pop" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "shipin" }
const _hoisted_7 = { class: "image" }
const _hoisted_8 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("video", {
      id: "video",
      class: "video",
      loop: _ctx.video.loop,
      crossOrigin: "anonymous",
      "webkit-playsinline": "true",
      playsinline: "",
      "x5-playsinline": "",
      src: _ctx.video.url,
      style: _ctx.video.type === 1 ? 'display:none' : ''
    }, [
      _createVNode("source", {
        src: _ctx.video.url
      }, null, 8, ["src"])
    ], 12, ["loop", "src"]), [
      [_vShow, _ctx.video.url && !(_ctx.pop && _ctx.pop.content)]
    ]),
    _hoisted_2,
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("img", {
        src: _ctx.video.btn,
        alt: "",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleIntro && _ctx.handleIntro(...args)))
      }, null, 8, ["src"])
    ], 512), [
      [_vShow, !_ctx.pop.video && !_ctx.pop.image && _ctx.page !== 3]
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("img", {
            class: "close",
            src: _imports_0,
            alt: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pop = {}))
          }),
          (_ctx.pop.video)
            ? (_openBlock(), _createBlock("video", {
                key: 0,
                src: _ctx.pop.video,
                controls: "",
                autoplay: "",
                loop: "",
                "webkit-playsinline": "true",
                playsinline: "",
                "x5-playsinline": ""
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (!_ctx.pop.video && _ctx.pop.image)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.pop.image,
                  alt: ""
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_8, [
          _createVNode("div", null, _toDisplayString(_ctx.pop.content), 1)
        ], 512), [
          [_vShow, _ctx.pop.content]
        ]),
        _withDirectives(_createVNode("img", {
          class: "img",
          src: _imports_1,
          alt: "",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
        }, null, 512), [
          [_vShow, _ctx.pop.enter]
        ]),
        _withDirectives(_createVNode("img", {
          class: "img",
          style: {"width":"29.6vw"},
          src: _imports_2,
          alt: "",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCamera && _ctx.handleCamera(...args)))
        }, null, 512), [
          [_vShow, _ctx.pop.camera]
        ])
      ])
    ], 512), [
      [_vShow, _ctx.pop && (_ctx.pop.video || _ctx.pop.image)]
    ])
  ]))
})